/* eslint-disable complexity */
/*eslint max-lines-per-function: ["error", 400]*/
import React from 'react';
import { Form, Tab, Tabs } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateCardDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';
import {
  FormControlTextarea10,
  FormControlTextarea16,
  FormControlTextarea3,
} from '../../../app/components/FormControlTextarea';
import { ChooseSigned } from '../Users/ChooseSigned';
import { Role } from '../../../common/spdCore/authorization/roles';
import { RadioButtonTextsWithDesc } from '../../../common/components/RadioButtonTextsWithDesc';

import { CardStatusFields } from './CardStatusFields';

interface CardPsychologicalEditorProps {
  card: CreateUpdateCardDto;
  id: string | undefined;
  propertyChange: (obj: Partial<CreateUpdateCardDto>) => void;
}

export const CardPsychologicalEditor: React.FC<
  CardPsychologicalEditorProps
> = ({ card, id, propertyChange }) => {
  return (
    <>
      <Tabs defaultActiveKey="justification" id="data" className="mb-2">
        <Tab eventKey="justification" title="Uzasadnienie" className="mb-2">
          <div className="d-grid gap-3">
            <FormRow controlId="pass" label="Wynik pozytywny">
              <Form.Check
                type="checkbox"
                defaultChecked={
                  card?.pass || card?.pass === undefined || card?.pass === null
                    ? true
                    : false
                }
                onChange={e => propertyChange({ pass: e.target.checked })}
              />
            </FormRow>
            <FormRow
              controlId="twilightVision"
              label="Widzenie zmierzchowe w normie"
            >
              <Form.Check
                type="checkbox"
                defaultChecked={
                  card?.twilightVision ||
                  card?.twilightVision === undefined ||
                  card?.twilightVision === null
                    ? true
                    : false
                }
                onChange={e =>
                  propertyChange({ twilightVision: e.target.checked })
                }
              />
            </FormRow>
            <FormRow
              controlId="glareSensitivity"
              label="Wrażliwość na olśnienie w normie"
            >
              <Form.Check
                type="checkbox"
                defaultChecked={
                  card?.glareSensitivity ||
                  card?.glareSensitivity === undefined ||
                  card?.glareSensitivity === null
                    ? true
                    : false
                }
                onChange={e =>
                  propertyChange({ glareSensitivity: e.target.checked })
                }
              />
            </FormRow>
            <FormRow controlId="staff" label="Psycholog">
              <ChooseSigned
                userUID={card?.psychologistUID}
                handleOnChange={user =>
                  propertyChange({
                    psychologistUID: user?.uid,
                  })
                }
                roles={[Role.PsychologistAssessor, Role.PsychologistSpecialist]}
              />
            </FormRow>
            <FormRow controlId="number" label="Numer">
              <Form.Control
                type="text"
                disabled={
                  card?.cardDate && card.cardDate.getFullYear() > 2024
                    ? true
                    : false
                }
                value={
                  id || (card?.cardDate && card.cardDate.getFullYear() <= 2024)
                    ? card?.number || ''
                    : '-- Numer zostanie nadany automatycznie po zapisie --'
                }
                onChange={e =>
                  propertyChange({
                    number: e.target.value,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="cardDate" label="Data karty">
              <Form.Control
                type="date"
                name="datepic"
                required={false}
                placeholder="DateRange"
                value={momencik(card?.cardDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({
                    cardDate: e.target.value ? new Date(e.target.value) : null,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="justification" label="Uzasadnienie">
              <FormControlTextarea10
                defaultValue={card?.justification || ''}
                onChange={e =>
                  propertyChange({ justification: e.target.value })
                }
              />
            </FormRow>
            <CardStatusFields
              verified={card?.verified}
              withoutSign={card?.withoutSign}
              propertyChange={propertyChange}
            />
          </div>
        </Tab>
        <Tab eventKey="interview" title="Wywiad" className="mb-2">
          <FormRow controlId="interview" label="Wywiad">
            <FormControlTextarea16
              defaultValue={card?.interview || ''}
              onChange={e => propertyChange({ interview: e.target.value })}
            />
          </FormRow>
        </Tab>
        <Tab eventKey="observation" title="Obserwacja badanego #1">
          <RadioButtonTextsWithDesc
            name="Wygląd zewnętrzny"
            value={card.externalAppearance}
            field={{ externalAppearance: '' }}
            onChange={propertyChange}
            texts={[
              'bardzo zadbany',
              'zadbany',
              'typowy',
              'wyróżniający się',
              'niezadbany',
            ]}
          />
          <RadioButtonTextsWithDesc
            name="Zachowanie w trakcie badania"
            value={card.behaviorTesting}
            field={{ behaviorTesting: '' }}
            onChange={propertyChange}
            texts={[
              'kulturalne',
              'niekulturalne',
              'adekwatne do sytuacji',
              'pewny siebie',
              'zbyt pewny siebie',
              'nie wierzy w siebie',
            ]}
          />
          <RadioButtonTextsWithDesc
            name="Ogólny nastrój badanego"
            value={card.generalMood}
            field={{ generalMood: '' }}
            onChange={propertyChange}
            texts={['zrównoważony', 'niezrównoważony', 'pogodny', 'smutny']}
          />
          <RadioButtonTextsWithDesc
            name="Poziom zainteresowania badaniem"
            value={card.levelOfInterest}
            field={{ levelOfInterest: '' }}
            onChange={propertyChange}
            texts={[
              'niezainteresowany',
              'mało zainteresowany',
              'zainteresowany',
              'bardzo zainteresowany',
              'nadmiernie',
            ]}
          />
          <RadioButtonTextsWithDesc
            name="Stosunek do psychologa"
            value={card.attitudeToPsychologist}
            field={{ attitudeToPsychologist: '' }}
            onChange={propertyChange}
            texts={[
              'życzliwy',
              'niechętny',
              'uległy',
              'dominujący',
              'roszczeniowy',
              'łatwy w kontakcie',
              'trudny w kontakcie',
            ]}
          />
          <RadioButtonTextsWithDesc
            name="Zdolność wypowiadania się"
            value={card.abilityToExpressYourself}
            field={{ abilityToExpressYourself: '' }}
            onChange={propertyChange}
            texts={['płynna', 'dobra', 'słaba', 'odpowiada']}
          />
          <RadioButtonTextsWithDesc
            name="Samokontrola"
            value={card.selfControl}
            field={{ selfControl: '' }}
            onChange={propertyChange}
            texts={[
              'przejawia negatywne',
              'lęk wpływa na wyniki',
              'lęk nie wpływa na wyniki',
            ]}
          />
        </Tab>
        <Tab eventKey="observation2" title=".. #2">
          <RadioButtonTextsWithDesc
            name="Reakcja na porażkę"
            value={card.reactionToFailure}
            field={{ reactionToFailure: '' }}
            onChange={propertyChange}
            texts={[
              'podchodzi w sposób',
              'zniechęca się',
              'oskarża siebie',
              'próbuje unikać',
              'robi wrażenie',
              'oskarża/obwinia',
              'przerzuca winę',
            ]}
          />
          <RadioButtonTextsWithDesc
            name="Rozumienie instrukcji"
            value={card.understandingTheInstructions}
            field={{ understandingTheInstructions: '' }}
            onChange={propertyChange}
            texts={[
              'szybko rozumie',
              'przeciętnie',
              'niezbyt dobre',
              'wymaga dodatkowych wyjaśnień',
              'pracuje z trudnością',
              'nie rozumie',
            ]}
          />
          <RadioButtonTextsWithDesc
            name="Uwaga"
            value={card?.attention}
            field={{ attention: '' }}
            onChange={propertyChange}
            texts={['uważny', 'dość uważny', 'niezbyt uważny', 'rozprasza się']}
          />
          <RadioButtonTextsWithDesc
            name="Tempo pracy"
            value={card?.workPace}
            field={{ workPace: '' }}
            onChange={propertyChange}
            texts={['szybkie', 'średnie', 'raczej wolne', 'bardzo wolne']}
          />
          <RadioButtonTextsWithDesc
            name="Poziom pobudzenia"
            value={card?.arousalLevel}
            field={{ arousalLevel: '' }}
            onChange={propertyChange}
            texts={[
              'zrównoważony',
              'zahamowany',
              'aktywny',
              'ożywiony',
              'spięty i zorganizowany',
              'napięty',
            ]}
          />
          <RadioButtonTextsWithDesc
            name="Zachowanie pod presją czasu"
            value={card?.behaviorUnderPressure}
            field={{ behaviorUnderPressure: '' }}
            onChange={propertyChange}
            texts={[
              'skoncentrowany',
              'emocjonalne',
              'reaguje lękiem i złością',
              'słowotok',
              'używa wulgaryzmów',
              'poddaje się',
            ]}
          />
        </Tab>
        <Tab eventKey="physical" title="Wnioski">
          <div className="d-grid gap-3">
            <FormRow
              controlId="intellectualAbility"
              label="Sprawność intelektualna"
            >
              <FormControlTextarea3
                defaultValue={card?.intellectualAbility || ''}
                onChange={e =>
                  propertyChange({
                    intellectualAbility: e.target.value,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="personality" label="Osobowość">
              <FormControlTextarea3
                defaultValue={card?.personality || ''}
                onChange={e => propertyChange({ personality: e.target.value })}
              />
            </FormRow>
            <FormRow
              controlId="psychomotorEfficiency"
              label="Sprawność psychomotoryczna"
            >
              <FormControlTextarea3
                defaultValue={card?.psychomotorEfficiency || ''}
                onChange={e =>
                  propertyChange({
                    psychomotorEfficiency: e.target.value,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="conclusions" label="Wnioski">
              <FormControlTextarea3
                defaultValue={card?.conclusions || ''}
                onChange={e => propertyChange({ conclusions: e.target.value })}
              />
            </FormRow>
            <FormRow controlId="recommendations" label="Zalecenia">
              <FormControlTextarea3
                defaultValue={card?.recommendations || ''}
                onChange={e =>
                  propertyChange({ recommendations: e.target.value })
                }
              />
            </FormRow>
            <FormRow controlId="cardDate" label="Data karty">
              <Form.Control
                type="date"
                name="datepic"
                required={false}
                placeholder="DateRange"
                value={momencik(card?.cardDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({
                    cardDate: e.target.value ? new Date(e.target.value) : null,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="postDate" label="Data wysłania">
              <Form.Control
                type="date"
                name="datepic"
                placeholder="DateRange"
                value={momencik(card?.postDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({
                    postDate: new Date(e.target.value),
                  })
                }
              />
            </FormRow>
          </div>
        </Tab>
      </Tabs>
    </>
  );
};
